(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.trans = this.dataset.trans;
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headersub = document.querySelector('.header-wrapper');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.setHeaderHeight();
      var section = document.getElementById(
        "shopify-section-sections--19784076689665__collection_icons_LYrLpn"
      );
      this.cardContents = section.querySelectorAll(".card__content");
      window.matchMedia('(max-width: 992px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
      this.onScroll();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if(scrollTop >= 60 && scrollTop <= 100) return; 

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom || scrollTop > this.header.offsetHeight ) {
      // if (scrollTop != 0) {
        this.header.classList.add('scrolled-past-header');
        this.cardContents.forEach((cardContent) => {
          //cardContent.classList.add("hidden");
        });
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom || scrollTop > this.header.offsetHeight ) {
        this.header.classList.add('scrolled-past-header');
        this.cardContents.forEach((cardContent) => {
          //cardContent.classList.add("hidden");
        });
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top || scrollTop < this.header.offsetHeight) {
        this.header.classList.remove('scrolled-past-header');
        this.cardContents.forEach((cardContent) => {
          cardContent.classList.remove("hidden");
        });
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);





    function isOpenNow(schedule) {
      const days = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
      const now = new Date();
      const dayName = days[now.getDay()];
      const today = schedule?.[dayName];

      if (!today || !today.open || !today.close) return { open: false, closeTime: null };

      const [openHour, openMin] = today.open.split(':').map(Number);
      const [closeHour, closeMin] = today.close.split(':').map(Number);

      const nowMinutes = now.getHours() * 60 + now.getMinutes();
      const openMinutes = openHour * 60 + openMin;
      const closeMinutes = closeHour * 60 + closeMin;

      const open = nowMinutes >= openMinutes && nowMinutes < closeMinutes;

      return { open, closeTime: today.close };
    }




  
  document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('.section-header');
  const headerWrapper = document.querySelector('.header-wrapper');
  let headerIsAlwaysSticky = headerWrapper && headerWrapper.dataset.stickyType === 'always' || headerWrapper.dataset.stickyType === 'reduce-logo-size';
  let headerBounds = {};
  let currentScrollTop = 0;
  // let preventReveal = false;
  // let isScrolling;

const selectedLocation = JSON.parse(
  localStorage.getItem("selected_location") || "null"
);
if (selectedLocation) {
  const containerLocation = document.getElementById("header-button-location");
  if (containerLocation) {
    containerLocation.innerHTML = "";
    const { open, closeTime } = isOpenNow(selectedLocation.schedule);
    const div = document.createElement("div");
    div.className = "header-button-location-content";
    div.innerHTML = `
      <div class="drawer-address">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
      <path d="M8 0C5.243 0 3 2.243 3 5c0 3.25 4.5 9 5 9s5-5.75 5-9c0-2.757-2.243-5-5-5zm0 7a2 2 0 1 1 0-4 2 2 0 0 1 0 4z"/>
    </svg>
        ${selectedLocation.city || ""}, ${
      selectedLocation.province || ""
    }
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24" >
      <polyline points="6 9 12 15 18 9"/>
    </svg>
    </div>
      <div class="drawer-content-address">
        <span class="drawer-status" style="color: ${open ? "green" : "red"};">${
      open ? "Abierto" : "Cerrado"
    }</span> - 
        <span class="drawer-closing-time">${
          closeTime ? "Cierra a las " + closeTime : "Sin horario"
        }</span>
      </div>
    `;
    div.addEventListener("click", () => {
      if (typeof DrawerLocator?.show === "function") {
        DrawerLocator.show();
      } else {
        console.warn("DrawerLocator.show no está definido");
      }
    });
    containerLocation.appendChild(div);
  }
}

window.addEventListener("storage", function (e) {
  if (e.detail?.key === "location_change") {
    const updatedLocation = JSON.parse(
      localStorage.getItem("selected_location") || "null"
    );
    if (updatedLocation) {
      const containerLocation = document.getElementById(
        "header-button-location"
      );
      if (containerLocation) {
        containerLocation.innerHTML = "";
        const { open, closeTime } = isOpenNow(updatedLocation.schedule);
        const div = document.createElement("div");
        div.className = "header-button-location-content";
        div.innerHTML = `
      <div class="drawer-address">
         <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
      <path d="M8 0C5.243 0 3 2.243 3 5c0 3.25 4.5 9 5 9s5-5.75 5-9c0-2.757-2.243-5-5-5zm0 7a2 2 0 1 1 0-4 2 2 0 0 1 0 4z"/>
    </svg>
        ${updatedLocation.city || ""}, ${
      updatedLocation.province || ""
    }
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24" >
      <polyline points="6 9 12 15 18 9"/>
    </svg>
        </div>
      <div class="drawer-content-address">
        <span class="drawer-status" style="color: ${open ? "green" : "red"};">${
          open ? "Abierto" : "Cerrado"
        }</span> - 
        <span class="drawer-closing-time">${
          closeTime ? "Cierra a las " + closeTime : "Sin horario"
        }</span>
      </div>
    `;
        div.addEventListener("click", () => {
          if (typeof DrawerLocator?.show === "function") {
            DrawerLocator.show();
          } else {
            console.warn("DrawerLocator.show no está definido");
          }
        });
        containerLocation.appendChild(div);
      }
    }

  }
});


  const onScroll = () => {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    
    if (!header) return;
    if (!headerIsAlwaysSticky) {
      if (scrollTop > currentScrollTop && scrollTop > headerBounds.bottom || scrollTop > header.offsetHeight) {
        header.classList.add('not_sticky');
      } else if (scrollTop < currentScrollTop && scrollTop > headerBounds.bottom || scrollTop > header.offsetHeight) {
        header.classList.add('not_sticky');
      } else if (scrollTop <= headerBounds.top || scrollTop < header.offsetHeight) {
        header.classList.remove('not_sticky');
      }
    } 
    currentScrollTop = scrollTop;
  };
  window.addEventListener('scroll', onScroll, false);
});


  } catch(e) { console.error(e); }
})();
})();
